var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"form-checkbox",attrs:{"hide-details":"auto","label":_vm.element.text,"rules":_vm.element.mandatory ? _vm.rules : [],"error":_vm.error},on:{"change":_vm.emitAnswerUpdate},model:{value:(_vm.element.answer),callback:function ($$v) {_vm.$set(_vm.element, "answer", $$v)},expression:"element.answer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }